(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  document.querySelectorAll('.search-icon').forEach(search => {
    search.addEventListener('click', openSearch)
  });
    
  function openSearch(){
    var searchOuter = document.querySelector('#search-outer');
    searchOuter.classList.add('animate', 'active');
    searchOuter.setAttribute('aria-hidden', 'false');
    document.querySelector('#header-search-overlay').classList.add('animate')
    disableScrolling();

    searchOuter.addEventListener('transitionend', () => {
      searchOuter.focus();
      trapFocus(searchOuter, searchOuter.querySelector('input[type="search"]'));
    }, { once: true });
  }

  //Mobile Link Click Animations 
  var menuBtns = document.getElementsByClassName("header-link-inner")
  for(let menuBtn of menuBtns){
    if(menuBtn.parentNode.getElementsByClassName("header-link-dropdown-outer")[0]){
      menuBtn.addEventListener("click", (e) => { 
        if(window.matchMedia("(max-width: 991px)").matches){  
          HeightChange(e.currentTarget.parentNode.getElementsByClassName("header-link-dropdown-outer")[0]);
          e.currentTarget.parentNode.getElementsByClassName("link-arrow-wrapper")[0].classList.toggle("link-arrow-wrapper-rotate");   
        }
      })
    }
  }
  
  //Mobile Open/Close Menu
  var navigationBtn = document.getElementById("menu-button");
  var linksContainer = document.getElementById("main-links-container");

  function openCloseMenu(){
      linksContainer.classList.toggle("open-close-menu");
      document.getElementById("open-menu-icon").classList.toggle("zero-opacity");
      document.getElementById("close-menu-icon").classList.toggle("full-opacity");
      linksContainer.querySelectorAll(".header-link-dropdown-outer").forEach((dropdown) => {
        dropdown.classList.toggle("show")
      })
      navigationBtn.setAttribute('aria-expanded', navigationBtn.getAttribute('aria-expanded') === 'true' ? 'false' : 'true')
  }

  if(navigationBtn){
    navigationBtn.addEventListener("click", () => {
      if(window.matchMedia("(max-width: 991px)").matches){
        openCloseMenu();
      }
    })
  }

  //on resize
  window.addEventListener("resize",debounce(() => {
    if(window.matchMedia("(max-width: 991px)").matches){
      trapFocus(document.getElementById("header"))
      headerHeight()
    }else{
      removeTrapFocus();
      if(navigationBtn.getAttribute('aria-expanded') === 'true'){
        openCloseMenu();
      }
    }
  }));

  if(window.matchMedia("(max-width: 991px)").matches){  
    trapFocus(document.getElementById("header"))
    headerHeight();
  }

  function headerHeight(){
    var header = document.getElementById("header");
    var linkContainer = document.getElementById("main-links-container");
    linkContainer.style.maxHeight = `calc(100vh - ${header.offsetHeight}px)`;
  }

  //Sticky header
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.menu = document.getElementById('main-links-container')
      this.searchContainer = document.querySelector('#search-outer');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);    

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.searchContainer && this.searchContainer.getAttribute('aria-hidden') == 'false') return;
     
      if(this.menu.classList.contains('open-close-menu')) {
        requestAnimationFrame(this.reveal.bind(this));
        return
      }
      else if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
      

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              lazyLoadImages();
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 1000px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
